/**
 * Tabs Entrenamiento | FOOD PLAN para coaches que operan ambos productos
 * sin salir del shell (misma sesión).
 */
export default function CoachProductTabs({
  active = 'training',
  showTraining = true,
  showFood = true,
  onSelectTraining,
  onSelectFood,
}) {
  if (!showTraining || !showFood) return null;

  const tabClass = (id) =>
    `px-4 py-2 text-sm font-semibold rounded-lg border transition-colors ${
      active === id
        ? 'bg-stone-900 text-white border-stone-900'
        : 'bg-white text-stone-800 border-stone-300 hover:bg-stone-50'
    }`;

  return (
    <div
      className="flex flex-wrap items-center gap-2 mb-4 p-1 rounded-xl border border-stone-200 bg-stone-50"
      role="tablist"
      aria-label="Productos del coach"
    >
      <button
        type="button"
        role="tab"
        aria-selected={active === 'training'}
        className={tabClass('training')}
        onClick={onSelectTraining}
      >
        Entrenamiento
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === 'food-plan'}
        className={tabClass('food-plan')}
        onClick={onSelectFood}
      >
        FOOD PLAN
      </button>
      <p className="text-xs text-stone-500 ml-auto px-2 hidden sm:block">
        Mismos asesorados · sin salir de la app
      </p>
    </div>
  );
}
